// src/utils/authUtils.ts
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Récupère le rôle d’un utilisateur à partir de son email (clé du doc dans Firestore).
 */
export const getUserRole = async (email: string): Promise<string | null> => {
  try {
    if (!email) {
      console.warn("❌ Email manquant pour getUserRole()");
      return null;
    }

    const emailKey = email.trim().toLowerCase();
    const docRef = doc(db, "Users", emailKey);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.warn(`❌ Aucun document trouvé pour : ${emailKey}`);
      return null;
    }

    const data = docSnap.data();
    const role = data?.role;

    console.log(`✅ Rôle trouvé pour ${emailKey} :`, role);
    return role || null;

  } catch (error) {
    console.error("❌ Erreur dans getUserRole :", error);
    return null;
  }
};
